import { call, put, select } from 'redux-saga/effects'
import { updateContractConfigData } from '../../SubscriptionForm/SubscriptionFormSlice'
import { callApi } from '@/shared/tools/apiSagaHelper'
import { selectExtraRoutesAuthData } from '../../../Login/AuthSelectors'
import * as Sentry from '@sentry/react'

export const propaneModuleActions = {
  PROPANE_LOAD_QUOTE_REASONS_V2: 'PROPANE_LOAD_QUOTE_REASONS_V2',
  PROPANE_LOAD_VISIBILITY_V2: 'PROPANE_LOAD_VISIBILITY_V2',
}

export function* loadPropaneQuoteReasons({ contractId }) {
  const { propaneQuotesReasonsUrl } = yield select(selectExtraRoutesAuthData)
  const endpoint = `${propaneQuotesReasonsUrl}?&energy=propane`

  try {
    const quoteReasonsList = yield call(callApi, { endpoint })
    yield put(updateContractConfigData({ id: contractId, data: { quoteReasonsList } }))
  } catch (error) {
    const status = error?.status || 'unknown'
    if (import.meta.env.PROD && status !== 422) {
      Sentry.captureException(new Error('loadQuoteReasonError'), { extra: { error } })
    }
  }
}

export function* loadPropaneVisibility({ contractId, workflow }) {
  const { propaneVisibilityUrl } = yield select(selectExtraRoutesAuthData)
  const fullUrl = `${propaneVisibilityUrl}?&workflowName=${workflow}`

  try {
    const propaneVisibility = yield call(callApi, { endpoint: fullUrl })
    yield put(
      updateContractConfigData({ id: contractId, data: { propaneVisibility: propaneVisibility.visibility ?? {} } }),
    )
  } catch (error) {
    const status = error?.status || 'unknown'
    if (import.meta.env.PROD && status !== 422) {
      Sentry.captureException(new Error('loadPropaneVisibilityError'), { extra: { error } })
    }
  }
}
